var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('fragment', [_c('WTitle', {
    staticClass: "type2",
    attrs: {
      "tag-name": "h4"
    }
  }, [_vm._v("작가 소개")]), _c('div', {
    staticClass: "book_info_content book_info_profile"
  }, _vm._l(_vm.processedAuthorList, function (author, index) {
    return _c('dl', {
      key: index,
      staticClass: "author_profile"
    }, [_c('dt', {
      staticClass: "author_profile_info"
    }, [_c('strong', {
      staticClass: "profile_name"
    }, [_vm._v(_vm._s(author.name)), _vm.isKidsBook ? [_vm._v("(" + _vm._s(author.typeText) + ")")] : _vm._e()], 2)]), _c('LineBreakElement', {
      staticClass: "author_profile_desc",
      attrs: {
        "tag-name": "dd",
        "contents": author.introduction
      }
    })], 1);
  }), 0)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }